import styled from "@emotion/styled";
import { fontColor, FONTS, fontSize } from "../../../../../../../styles/fonts";

export const ShowAddressHeadline = styled.span`
  ${fontColor.black};
  ${fontSize.x2};
  ${FONTS.SwarovskiFutura500};

  display: block;
  margin-bottom: 15px;
`;
